var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullyTransparentsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.8801C1 8.98676 1 6.54013 1.57252 5.71702C2.14502 4.89392 4.42478 4.10645 8.98432 2.53151L9.853 2.23147C12.2298 1.41049 13.4181 1 14.6486 1C15.8791 1 17.0675 1.41049 19.4443 2.23147L20.313 2.53151C24.8725 4.10645 27.1523 4.89392 27.7248 5.71702C28.2973 6.54013 28.2973 8.98676 28.2973 13.8801C28.2973 14.6191 28.2973 15.4207 28.2973 16.2899C28.2973 24.9177 21.8688 29.1048 17.8355 30.8827C16.7414 31.3649 16.1944 31.6061 14.6486 31.6061C13.1029 31.6061 12.5559 31.3649 11.4618 30.8827C7.42845 29.1048 1 24.9177 1 16.2899C1 15.4207 1 14.6191 1 13.8801Z",
    stroke: "#A1E6F6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61667 15.8888L12.0287 20.0247L20.8517 11.7528",
    stroke: "#A1E6F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullyTransparentsvg);
export default __webpack_public_path__ + "static/media/fullyTransparentsvg.3cf20c515f2cdb7925036170cd9a4fd5.svg";
export { ForwardRef as ReactComponent };